import { Divider } from '@mui/material';
import { usePlanContext } from '../context/PlanContext';
import { CalendarFilter } from './components/CalendarFilter';
import { CalendarPrintDrawer } from './components/CalendarPrintDrawer';
import { MainCalendar } from './components/mainCalendar/MainCalendar';
import { CalendarHeader } from './components/mainCalendar/MainCalendarHeader';
import { MiniCalendar } from './components/miniCalendar/MiniCalendar';
import { CalendarProvider } from './context/CalendarContext';

export function CalendarPage() {
  const { printDrawerOpen, setPrintDrawerOpen } = usePlanContext();

  return (
    <CalendarProvider>
      <div className="flex h-full w-full overflow-hidden select-none">
        <div className="flex flex-1 flex-col min-w-0 min-h-0 p-4 bg-gray-50 overflow-hidden">
          <CalendarHeader />
          <MainCalendar />
        </div>

        <div className="flex flex-col shrink-0 border-l border-gray-300 h-full overflow-hidden">
          <div className="p-4 shrink-0">
            <MiniCalendar />
          </div>

          <Divider className="shrink-0" />

          <div className="flex-1 min-h-0 p-4">
            <CalendarFilter />
          </div>
        </div>
      </div>

      <CalendarPrintDrawer
        open={printDrawerOpen}
        onClose={() => setPrintDrawerOpen(false)}
      />
    </CalendarProvider>
  );
}
